define('models/base/table',['require','models/base/model'],function(require) {
    'use strict';

    var Model = require('models/base/model');

    var TableModel = Model.extend({
        defaults: {
            items: []
        },
        parse: function(data) {
            return {
                items: data
            };
        }
    });

    return TableModel;
});

